import GroupControllers from './GroupControllers';

export default GroupControllers;
